<template>
  <div class="pic-box">
    <img class="bg" src="~@images/login.png" alt>
    <img class="logo" src="~@images/logo.png" alt>
    <div class="top">
      <!-- <h1>文物智慧化综合业务管理平台</h1> -->
      <!-- <p class="trans">Background managemen system</p> -->
    </div>
    <!-- <p class="bottom m-tips">技术支持 北京探景科技</p> -->
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.pic-box {
  position: relative;
  img.bg {
    // width: 500px;
    // height: 430px;
    width: 530px;
    height: 592px;
    box-shadow: 0px 10px 20px 0px rgba(181, 177, 221, 0.3);
  }
  img.logo {
    position: absolute;
    bottom: 20px;
    left: 50%;
    margin-left: -65px;
    width: 130px;
  }
  .top {
    position: absolute;
    top: 50%;
    // margin-top: -55px;
    margin-top: -125px;
    // left: 50px;
    width: 100%;
    h1 {
      margin-bottom: 0;
      // margin-top: 20px;
      // margin-bottom: 10px;
      // font-size: 42px;
      font-size: 32px;
      color: #fff;
      text-align: center;
    }
    .trans {
      font-size: 16px;
      color: #fff;
    }
  }
  .bottom {
    position: absolute;
    bottom: 30px;
    left: 50px;
    color: #fff;
  }
}
</style>


